export const checkIncludeNotNumber = (string: string) => {
  return !/[^0-9]/.test(string) && !/^0/.test(string);
};
